function toggleFaq() {
  let button = $('.chat-button__button');
  button.on('click', function () {
    $(this).parent().toggleClass('active');
    button.not(this).parent().removeClass('active');
  });
}
toggleFaq();